var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('v-tooltip',{attrs:{"disabled":!_vm.activeText,"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({},on),[_vm._v(_vm._s(_vm.activeIcon))])]}}],null,false,323479428)},[_vm._v(_vm._s(_vm.activeText))]):_c('v-tooltip',{attrs:{"disabled":!_vm.inactiveText,"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({},on),[_vm._v(_vm._s(_vm.inactiveIcon))])]}}])},[_vm._v(_vm._s(_vm.inactiveText))])}
var staticRenderFns = []

export { render, staticRenderFns }